import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { usePaymentIntent } from '../contexts/PaymentIntentProvider';
import { createRating } from '../utils/ratingHelpers';

const DEFAULT_COLOR = '#8b979c';
const HAPPY_COLOR = '#06b3a2';
const SAD_COLOR = '#e05555';

const RatingFace = ({ variant, color }) => (
    <svg className="rating-face" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.8" />
        <circle cx="8.5" cy="10" r="1.15" fill={color} />
        <circle cx="15.5" cy="10" r="1.15" fill={color} />
        {variant === 'happy'
            ? <path d="M7.5 14.2c1 1.5 2.6 2.4 4.5 2.4s3.5-.9 4.5-2.4" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
            : <path d="M7.5 16c1-1.5 2.6-2.4 4.5-2.4s3.5.9 4.5 2.4" stroke={color} strokeWidth="1.8" strokeLinecap="round" />}
    </svg>
);

const RatingSelection = () => {
    const { id } = useParams();

    const [ selected, setSelected ] = useState('');
    const [ saving, setSaving ] = useState(false);
    const [ error, setError ] = useState('');

    const { setRating } = usePaymentIntent();

    const handleRating = async (value) => {
        if (saving) return;

        setSelected(value);
        setSaving(true);
        setError('');

        try {
            const rating = await createRating(id, value);
            setRating(rating); // advances to the next step in StripeContainer
        } catch (err) {
            console.error('Error saving rating:', err);
            setError('Something went wrong saving your rating. Please try again.');
            setSelected('');
            setSaving(false);
        }
    }

    return(
        <div className="payment-container">
            <p className="thank-you-title">Thank you for choosing The Perfect Clean</p>
            <p className="rating-title">How did we do?</p>
            <p className="rating-subtitle">Your rating helps us keep improving.</p>
            <div className="rating-options">
                <button
                    className={`rating-option ${selected === 'happy' ? 'rating-option-happy' : ''}`}
                    onClick={() => handleRating('happy')}
                    disabled={saving}
                >
                    <RatingFace variant="happy" color={selected === 'happy' ? HAPPY_COLOR : DEFAULT_COLOR} />
                </button>
                <button
                    className={`rating-option ${selected === 'sad' ? 'rating-option-sad' : ''}`}
                    onClick={() => handleRating('sad')}
                    disabled={saving}
                >
                    <RatingFace variant="sad" color={selected === 'sad' ? SAD_COLOR : DEFAULT_COLOR} />
                </button>
            </div>
            {saving && <p className="rating-saving">Saving your rating&hellip;</p>}
            {error && <p className="error-message">{error}</p>}
        </div>
    )
}

export default RatingSelection;
